const LABELS = {
  defaultPageTitle: 'HireReview',
  smartBudgetPageTitle: 'SmartBudgets | HireReview',
  workforcePageTitle: 'Workforce | HireReview',
}

export default LABELS
